import { useState } from "react";
import { ArrowLeft, Coins, KeyRound, TrendingUp } from "lucide-react";
import TierKeyPanel from "@/components/dashboard/TierKeyPanel";
import CashOutPanel from "@/components/dashboard/CashOutPanel";
import EarnedLedgerTracker from "@/components/dashboard/EarnedLedgerTracker";

// Consolidated Wallet & Monetization hub — reached from Misteck Life → Wealth.
// Self-contained S20 overlay with sub-tabs: Tier & Keys | Earnings | Cash-Out.
const SUBTABS = [
  { key: "tier", label: "Tier & Keys", Icon: KeyRound },
  { key: "earnings", label: "Earnings", Icon: TrendingUp },
  { key: "cashout", label: "Cash-Out", Icon: Coins },
];

export default function WalletMonetizationHub({ onBack }) {
  const [tab, setTab] = useState("tier");

  return (
    <div className="absolute inset-0 z-[45] flex flex-col bg-[#050505]" data-testid="wallet-monetization-hub">
      {/* Header */}
      <div className="flex items-center gap-2 border-b border-zinc-900 px-4 py-3">
        <button onClick={onBack} data-testid="wallet-hub-back" className="grid h-9 w-9 place-items-center rounded-xl border border-zinc-800 bg-zinc-900 active:scale-95">
          <ArrowLeft size={16} className="text-white" />
        </button>
        <div className="leading-tight">
          <p className="font-mono text-[9px] uppercase tracking-[0.24em] text-zinc-500">Misteck Wealth</p>
          <h2 className="font-serif text-xl text-white">Wallet & Monetization</h2>
        </div>
      </div>

      {/* Sub-tab pills */}
      <div className="flex gap-1.5 border-b border-zinc-900 px-3 py-2.5" data-testid="wallet-hub-tabs">
        {SUBTABS.map((t) => {
          const on = tab === t.key;
          const Icon = t.Icon;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`wallet-subtab-${t.key}`}
              className={[
                "flex flex-1 items-center justify-center gap-1.5 rounded-full border px-3 py-2 font-mono text-[10px] font-black uppercase tracking-wide transition-colors",
                on ? "border-[#FFCC00] bg-[#FFCC00] text-black" : "border-zinc-800 bg-[#0D0D0D] text-zinc-500",
              ].join(" ")}
            >
              <Icon size={13} /> {t.label}
            </button>
          );
        })}
      </div>

      {/* Body */}
      <div className="flex-1 overflow-y-auto no-scrollbar p-4 pb-28" data-testid={`wallet-hub-body-${tab}`}>
        {tab === "tier" && <TierKeyPanel />}
        {tab === "earnings" && <EarnedLedgerTracker />}
        {tab === "cashout" && <CashOutPanel />}
      </div>
    </div>
  );
}
